/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_6Inputs */

const en_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blossoming Turf`)
};

const ar_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العشب المتفتح`)
};

const de_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blühender Rasen`)
};

const es_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Césped floreciente`)
};

const fr_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapis de Pâquerettes`)
};

const it_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prato fiorito`)
};

const ja_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`花咲く芝生`)
};

const ko_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`꽃이 핀 잔디밭`)
};

const pt_br_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gramado florido`)
};

const ru_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цветущий газон`)
};

const th_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุ่งหญ้าเบ่งบาน`)
};

const tr_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çiçek Açan Çim`)
};

const zh_cn_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繁花草茵`)
};

const zh_tw_land_skin_6 = /** @type {(inputs: Land_Skin_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繁花草茵`)
};

/**
* | output |
* | --- |
* | "Blossoming Turf" |
*
* @param {Land_Skin_6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_6 = /** @type {((inputs?: Land_Skin_6Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_6Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_6(inputs)
	if (locale === "ar") return ar_land_skin_6(inputs)
	if (locale === "de") return de_land_skin_6(inputs)
	if (locale === "es") return es_land_skin_6(inputs)
	if (locale === "fr") return fr_land_skin_6(inputs)
	if (locale === "it") return it_land_skin_6(inputs)
	if (locale === "ja") return ja_land_skin_6(inputs)
	if (locale === "ko") return ko_land_skin_6(inputs)
	if (locale === "pt_br") return pt_br_land_skin_6(inputs)
	if (locale === "ru") return ru_land_skin_6(inputs)
	if (locale === "th") return th_land_skin_6(inputs)
	if (locale === "tr") return tr_land_skin_6(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_6(inputs)
	return zh_tw_land_skin_6(inputs)
});